module.exports = __webpack_public_path__ + "static/assets/ca942b1b0737f154d42f265aa8550836.svg";